export default __webpack_public_path__ + "static/media/book_9.3555ab17.svg";